module.exports = __webpack_public_path__ + "media/components/src/assets/images/user_info/img_login-7d195753718c5ec58cece4b00f74c9d6.svg";